export const capitalizeFirstWord = (str) => {
  return `${str[0].toUpperCase()}${str.slice(1)}`;
};

/**
 * Take an object and convert it to string with the values
 * and properties
 *
 * @param {Object} obj
 * @returns String
 */
export const stringifyObject = (obj) => {
  let text = "";
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const element = obj[key];
      if (element) {
        if (text.length) text = `${text}&${key}=${element}`;
        else text = `${key}=${element}`;
      }
    }
  }
  return text;
};
